/**
 * Keyed by election AND party: a plan is campaign strategy, and two parties viewing one election
 * must never share a cache entry.
 */
export const strongHoldKeys = {
	all: ['strong-hold'] as const,
	plan: (electionId: number, partyId: number) => [...strongHoldKeys.all, 'plan', electionId, partyId] as const,
	estimates: (electionId: number, partyId: number) => [...strongHoldKeys.all, 'estimate', electionId, partyId] as const,
	estimate: (electionId: number, partyId: number, includeActuals: boolean, grain: string) =>
		[...strongHoldKeys.estimates(electionId, partyId), includeActuals, grain] as const,
	preview: (electionId: number, partyId: number, signature: string) =>
		[...strongHoldKeys.all, 'preview', electionId, partyId, signature] as const,
	references: (electionId: number, partyId: number) => [...strongHoldKeys.all, 'references', electionId, partyId] as const,
	history: (electionId: number, partyId: number) => [...strongHoldKeys.all, 'history', electionId, partyId] as const,
};
